var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"min-charge-tip"},[_c('p',[_vm._v("2 hours minimum. We charge in every 30 minutes increments after 2 hours,this is just the minimum charge, not the final charge.")])])
}]

export { render, staticRenderFns }